import { handleError } from 'utils/js/error_helpers';

// Each environment reports to its own New Relic app; leave the ID unset in a .env file to disable the agent there.
const applicationID = process.env.REACT_APP_NEW_RELIC_APPLICATION_ID;
// Browser ingest key shared by every app in the account; New Relic designs it to be public.
const licenseKey = 'NRBR-6de8c2ecd8b0b0768a7';
const NEW_RELIC_ACCOUNT_ID = 399482;

// New Relic's config schema requires these snake_case keys.
/* eslint-disable camelcase */
const options = {
	info: {
		applicationID,
		beacon: 'bam.nr-data.net',
		errorBeacon: 'bam.nr-data.net',
		licenseKey,
		sa: 1,
	},
	init: {
		ajax: {
			deny_list: ['bam.nr-data.net'],
		},
		browser_consent_mode: {
			enabled: false,
		},
		distributed_tracing: {
			enabled: true,
		},
		performance: {
			capture_detail: false,
			capture_marks: false,
			capture_measures: true,
		},
		privacy: {
			cookies_enabled: true,
		},
	},
	loader_config: {
		accountID: NEW_RELIC_ACCOUNT_ID,
		agentID: applicationID,
		applicationID,
		licenseKey,
		trustKey: NEW_RELIC_ACCOUNT_ID,
	},
};
/* eslint-enable camelcase */

// Lazy-loaded so environments without New Relic never download the agent chunk.
// The dist path is used because webpack 4 can't resolve the package's `exports` subpath `loaders/browser-agent`.
if (applicationID) {
	import('@newrelic/browser-agent/dist/esm/loaders/browser-agent')
		.then(({ BrowserAgent }) => new BrowserAgent(options))
		.catch(handleError);
}
